/**
 * Preset player builds — predefined 12-card decks + 1 passive.
 * Selected at the start of a new run instead of the 6-step draft.
 * "Freestyle" (the old draft flow) is handled as a special case
 * in the selection screen, not as a build entry here.
 */

export interface PlayerBuild {
  id: string;
  codename: string;
  subtitle: string;
  description: string;
  /** Card template keys (with duplicates for multiples). */
  cardKeys: string[];
  /** Passive template key that comes with this build. */
  passiveKey: string;
}

export const PLAYER_BUILDS: PlayerBuild[] = [
  {
    id: 'gazelle',
    codename: 'GAZELLE',
    subtitle: 'Speed & Evasion',
    description: 'Built for covering ground fast and staying one step ahead. Sprint doubles give you burst movement, Taxi gets you across the city, and Misdirect throws the agent off your trail.',
    cardKeys: [
      'move', 'move', 'move', 'move',
      'shortcut',
      'improvisedStrike',
      'sprint', 'sprint',
      'taxi',
      'misdirect',
      'sweep',
      'spotter',
    ],
    passiveKey: 'longStride',
  },
  {
    id: 'bourne',
    codename: 'BOURNE',
    subtitle: 'Stealth & Adaptability',
    description: 'A versatile kit built around disappearing and adapting. Hide Inside and Stage Exit keep you invisible, Improvise lets you draw on the fly, and extra movement keeps you mobile.',
    cardKeys: [
      'move', 'move', 'move', 'move', 'move',
      'instinct',
      'improvisedStrike',
      'stageExit',
      'hideInside',
      'informant',
      'wireTap',
      'improvise',
    ],
    passiveKey: 'subwaySurfer',
  },
  {
    id: 'hawkeye',
    codename: 'HAWKEYE',
    subtitle: 'Intel & Disruption',
    description: 'An intel-heavy build focused on finding and disrupting the agent. Acoustic Ping and Bearing triangulate their position, Stakeout locks down an area, and Malware jams their deck.',
    cardKeys: [
      'move', 'move', 'move', 'move',
      'improvisedStrike',
      'decoy',
      'malware',
      'paradeRoute',
      'stakeout',
      'acousticPing',
      'bearing',
      'quickStep',
    ],
    passiveKey: 'headhunter',
  },
];
